import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { defineComponent, ref, computed, onMounted, resolveComponent, openBlock, createElementBlock, normalizeClass, unref, createBlock, createSlots, withCtx, createVNode, renderSlot, createCommentVNode, createElementVNode, renderList, normalizeProps, guardReactiveProps, resolveDynamicComponent } from 'vue';
import { useStyleConfig } from '../abstract';
import { useConfigProvider } from '../config-provider';
import { useRoute, useRouter } from 'vue-router';
import StepinLayout from '../stepin-layout';
import RouterMenu, { getRouterMenus, findChildren, findParentKeys } from '../router-menu';
import StepinHeader from './stepin-header';
import StepinLogo from './StepinLogo.js';
import SettingPanel from '../setting-panel';
import TabsView from '../tabs-view/TabsView.js';
import { Colors } from '../utils';
import { useHideEmptyMenu, useTabsViewSlots } from './hooks';
import { useResizeObserver } from '@vueuse/core';
import { Drawer } from 'ant-design-vue';
var _sfc_main = /*#__PURE__*/defineComponent({
  __name: 'StepinView',
  props: {
    menuBasePath: String,
    menuList: Array,
    theme: String,
    systemName: String,
    logoSrc: String,
    collapsed: {
      type: Boolean,
      default: undefined
    },
    themeList: Array,
    user: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    navMode: String,
    useTabs: {
      type: Boolean,
      default: true
    },
    showSetting: {
      type: Boolean,
      default: undefined
    },
    lastTabClosable: Boolean
  },
  emits: ["update:show-setting", "update:collapsed", "themeSelect", "update:theme", "copy-config"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useStyleConfig = useStyleConfig('view'),
      prefixCls = _useStyleConfig.prefixCls,
      rootPrefix = _useStyleConfig.rootPrefix;
    var sCollapsed = ref(false);
    var sShowSetting = ref(false);
    // 是否展开设置面板
    var settingVisible = computed({
      set: function set(val) {
        sShowSetting.value = val;
        emit('update:show-setting', val);
      },
      get: function get() {
        var _props$showSetting;
        return (_props$showSetting = props.showSetting) !== null && _props$showSetting !== void 0 ? _props$showSetting : sShowSetting.value;
      }
    });
    var route = useRoute();
    // 页面视窗类型
    var view = computed(function () {
      var _meta$_to_view;
      var _route$meta = route.meta,
        meta = _route$meta === void 0 ? {
          view: 'admin'
        } : _route$meta;
      var toView = (_meta$_to_view = meta._to_view) !== null && _meta$_to_view !== void 0 ? _meta$_to_view : meta.view;
      // 临时显示模式，计算后需要删除
      if (meta !== null && meta !== void 0 && meta._to_view) {
        delete meta._to_view;
      }
      return toView;
    });
    // 侧边菜单收起状态
    var bindCollapsed = computed({
      get: function get() {
        var _props$collapsed;
        return (_props$collapsed = props.collapsed) !== null && _props$collapsed !== void 0 ? _props$collapsed : sCollapsed.value;
      },
      set: function set(val) {
        sCollapsed.value = val;
        emit('update:collapsed', !props.collapsed);
      }
    });
    var getMenuTheme = function getMenuTheme(color) {
      return Colors.isDarkColor(color) ? 'dark' : 'light';
    };
    var configProvider = useConfigProvider();
    // 侧边主题
    var sideTheme = computed(function () {
      return getMenuTheme(configProvider.theme.color.middle['bg-side']);
    });
    // 顶部主题
    var headerTheme = computed(function () {
      return getMenuTheme(configProvider.theme.color.middle['bg-header']);
    });
    // 导航
    var navigation = computed(function () {
      var _props$navMode;
      return (_props$navMode = props.navMode) !== null && _props$navMode !== void 0 ? _props$navMode : 'side';
    });
    var router = useRouter();
    // 顶部菜单数据
    var headMenuList = computed(function () {
      if (props.navMode === 'head') {
        return props.menuList;
      } else if (props.navMode === 'mix') {
        var _props$menuList;
        var menuList = (_props$menuList = props.menuList) !== null && _props$menuList !== void 0 ? _props$menuList : getRouterMenus(router, props.menuBasePath);
        return menuList.map(function (menu) {
          var _menu$meta, _menu$children, _menu$children$;
          return {
            title: menu.title,
            path: menu.path,
            key: menu.key,
            meta: _objectSpread(_objectSpread({}, (_menu$meta = menu.meta) !== null && _menu$meta !== void 0 ? _menu$meta : {}), {}, {
              redirect: (_menu$children = menu.children) === null || _menu$children === void 0 ? void 0 : (_menu$children$ = _menu$children[0]) === null || _menu$children$ === void 0 ? void 0 : _menu$children$.path
            })
          };
        });
      }
      return [];
    });
    // 侧边菜单数据
    var sideMenuList = computed(function () {
      if (props.navMode === 'side') {
        return props.menuList;
      } else if (props.navMode === 'mix') {
        var _props$menuList2;
        var menuList = (_props$menuList2 = props.menuList) !== null && _props$menuList2 !== void 0 ? _props$menuList2 : getRouterMenus(router, props.menuBasePath);
        if (menuList.find(function (item) {
          return item.path === route.path;
        })) {
          return findChildren(menuList, route.path);
        } else {
          var parentKeys = findParentKeys(route.path, menuList);
          var parentKey = parentKeys[0];
          return parentKey ? findChildren(menuList, parentKey) : [];
        }
      }
      return [];
    });
    var isMobile = ref(false);
    // 混合模式下，隐藏空的侧边菜单
    useHideEmptyMenu(sideMenuList, navigation, isMobile);
    var _useTabsViewSlots = useTabsViewSlots(),
      tabsSlots = _useTabsViewSlots.slots;
    var viewContainer = ref();
    onMounted(function () {
      useResizeObserver(viewContainer.value, function (entries) {
        var entry = entries[0];
        var width = entry.contentRect.width;
        isMobile.value = width <= 726;
      });
    });
    function getElementById(id) {
      return document.getElementById(id);
    }
    return function (_ctx, _cache) {
      var _view$value, _ctx$$route, _ctx$$route$matched;
      var _component_router_view = resolveComponent("router-view");
      return openBlock(), createElementBlock("div", {
        ref_key: "viewContainer",
        ref: viewContainer,
        class: normalizeClass("".concat(unref(prefixCls), " ").concat(unref(prefixCls), "-").concat((_view$value = view.value) !== null && _view$value !== void 0 ? _view$value : 'admin', " ").concat(isMobile.value ? unref(prefixCls) + '-mobile' : '', " stepin-layout-theme"))
      }, [view.value === 'blank' || ((_ctx$$route = _ctx.$route) === null || _ctx$$route === void 0 ? void 0 : (_ctx$$route$matched = _ctx$$route.matched) === null || _ctx$$route$matched === void 0 ? void 0 : _ctx$$route$matched.length) === 0 ? (openBlock(), createBlock(_component_router_view, {
        key: 0
      })) : (openBlock(), createBlock(unref(StepinLayout), {
        key: 1,
        mode: navigation.value,
        collapsed: bindCollapsed.value
      }, createSlots({
        header: withCtx(function () {
          return [createVNode(unref(StepinHeader), {
            collapsed: bindCollapsed.value,
            "onUpdate:collapsed": _cache[0] || (_cache[0] = function ($event) {
              return bindCollapsed.value = $event;
            }),
            "show-trigger": navigation.value === 'side' || isMobile.value,
            avatar: __props.user.avatar,
            mode: navigation.value,
            username: __props.user.name,
            "user-menu-list": __props.user.menuList
          }, createSlots({
            _: 2 /* DYNAMIC */
          }, [navigation.value !== 'side' || isMobile.value ? {
            name: "logo",
            fn: withCtx(function () {
              return [createVNode(StepinLogo, {
                logo: __props.logoSrc,
                collapsed: bindCollapsed.value,
                title: __props.systemName,
                "show-name": !isMobile.value
              }, null, 8 /* PROPS */, ["logo", "collapsed", "title", "show-name"])];
            }),
            key: "0"
          } : undefined, _ctx.$slots.headerActions ? {
            name: "actions",
            fn: withCtx(function () {
              return [renderSlot(_ctx.$slots, "headerActions")];
            }),
            key: "1"
          } : undefined, navigation.value !== 'side' && !isMobile.value ? {
            name: "content",
            fn: withCtx(function () {
              return [createVNode(unref(RouterMenu), {
                basePath: __props.menuBasePath,
                theme: headerTheme.value,
                "menu-list": headMenuList.value,
                "popup-class-name": "".concat(unref(rootPrefix), "-header-theme"),
                "get-popup-container": function getPopupContainer() {
                  return getElementById('header-popup-container');
                },
                mode: "horizontal"
              }, null, 8 /* PROPS */, ["basePath", "theme", "menu-list", "popup-class-name", "get-popup-container"])];
            }),
            key: "2"
          } : undefined]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["collapsed", "show-trigger", "avatar", "mode", "username", "user-menu-list"])];
        }),
        default: withCtx(function () {
          var _ctx$$slots;
          return [isMobile.value ? (openBlock(), createBlock(unref(Drawer), {
            key: 0,
            width: unref(configProvider).theme.size['width-side'],
            class: normalizeClass("".concat(unref(prefixCls), "-mobile-menu ").concat(unref(rootPrefix), "-side-theme")),
            bodyStyle: {
              padding: 0
            },
            closable: false,
            visible: bindCollapsed.value,
            "onUpdate:visible": _cache[1] || (_cache[1] = function ($event) {
              return bindCollapsed.value = $event;
            }),
            placement: "left"
          }, {
            default: withCtx(function () {
              return [createVNode(StepinLogo, {
                logo: __props.logoSrc,
                title: __props.systemName
              }, null, 8 /* PROPS */, ["logo", "title"]), createVNode(unref(RouterMenu), {
                basePath: __props.menuBasePath,
                theme: sideTheme.value,
                "popup-class-name": "".concat(unref(rootPrefix), "-side-theme"),
                "get-popup-container": function getPopupContainer() {
                  return getElementById('side-popup-container');
                },
                mode: "inline",
                inlineCollapsed: false
              }, null, 8 /* PROPS */, ["basePath", "theme", "popup-class-name", "get-popup-container"])];
            }),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["width", "class", "visible"])) : createCommentVNode("v-if", true), createElementVNode("div", {
            class: normalizeClass("".concat(unref(prefixCls), "-main"))
          }, [__props.useTabs ? (openBlock(), createBlock(TabsView, {
            key: 0,
            "last-tab-closable": __props.lastTabClosable
          }, createSlots({
            _: 2 /* DYNAMIC */
          }, [(_ctx$$slots = _ctx.$slots) !== null && _ctx$$slots !== void 0 && _ctx$$slots.pageFooter ? {
            name: "footer",
            fn: withCtx(function () {
              return [renderSlot(_ctx.$slots, "pageFooter")];
            }),
            key: "0"
          } : undefined, renderList(unref(tabsSlots), function (slot) {
            return {
              name: slot.tabSlot,
              fn: withCtx(function (bindings) {
                return [renderSlot(_ctx.$slots, slot.name, normalizeProps(guardReactiveProps(bindings)))];
              })
            };
          })]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["last-tab-closable"])) : (openBlock(), createBlock(_component_router_view, {
            key: 1
          }, {
            default: withCtx(function (_ref2) {
              var Component = _ref2.Component;
              return [createElementVNode("div", {
                class: normalizeClass("".concat(unref(prefixCls), "-main-pure"))
              }, [createElementVNode("div", {
                class: normalizeClass("".concat(unref(prefixCls), "-main-pure-content"))
              }, [(openBlock(), createBlock(resolveDynamicComponent(Component)))], 2 /* CLASS */), createElementVNode("div", {
                class: normalizeClass("".concat(unref(prefixCls), "-main-pure-footer"))
              }, [renderSlot(_ctx.$slots, "pageFooter")], 2 /* CLASS */)], 2 /* CLASS */)];
            }),

            _: 3 /* FORWARDED */
          }))], 2 /* CLASS */), _ctx.$slots.footer ? (openBlock(), createElementBlock("div", {
            key: 1,
            class: normalizeClass("".concat(unref(prefixCls), "-footer"))
          }, [renderSlot(_ctx.$slots, "footer")], 2 /* CLASS */)) : createCommentVNode("v-if", true)];
        }),
        _: 2 /* DYNAMIC */
      }, [navigation.value !== 'head' && !isMobile.value ? {
        name: "side",
        fn: withCtx(function () {
          return [navigation.value === 'side' ? (openBlock(), createBlock(StepinLogo, {
            key: 0,
            logo: __props.logoSrc,
            collapsed: bindCollapsed.value,
            title: __props.systemName
          }, null, 8 /* PROPS */, ["logo", "collapsed", "title"])) : createCommentVNode("v-if", true), createVNode(unref(RouterMenu), {
            basePath: __props.menuBasePath,
            theme: sideTheme.value,
            "menu-list": sideMenuList.value,
            "popup-class-name": "".concat(unref(rootPrefix), "-side-theme"),
            "get-popup-container": function getPopupContainer() {
              return getElementById('side-popup-container');
            },
            mode: "inline",
            inlineCollapsed: bindCollapsed.value
          }, null, 8 /* PROPS */, ["basePath", "theme", "menu-list", "popup-class-name", "get-popup-container", "inlineCollapsed"])];
        }),
        key: "0"
      } : undefined]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["mode", "collapsed"])), createVNode(unref(SettingPanel), {
        visible: settingVisible.value,
        "onUpdate:visible": _cache[2] || (_cache[2] = function ($event) {
          return settingVisible.value = $event;
        }),
        "preset-list": __props.themeList,
        theme: __props.theme,
        onCopy: _cache[3] || (_cache[3] = function (config) {
          return emit('copy-config', config);
        }),
        "onUpdate:theme": _cache[4] || (_cache[4] = function (value) {
          return emit('update:theme', value);
        }),
        onThemeSelect: _cache[5] || (_cache[5] = function (value) {
          return emit('themeSelect', value);
        })
      }, {
        themeEditorTab: withCtx(function () {
          return [renderSlot(_ctx.$slots, "themeEditorTab")];
        }),
        _: 3 /* FORWARDED */
      }, 8 /* PROPS */, ["visible", "preset-list", "theme"])], 2 /* CLASS */);
    };
  }
});

var _export_sfc = function _export_sfc(sfc, props) {
  var target = sfc.__vccOpts || sfc;
  var _iterator = _createForOfIteratorHelper(props),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        key = _step$value[0],
        val = _step$value[1];
      target[key] = val;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return target;
};
var StepinView = /* @__PURE__ */_export_sfc(_sfc_main, [["__file", "/Users/chenghongxing/VsCodeProjects/stepin/components/stepin-view/StepinView.js"]]);
export { StepinView as default };